var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"sanitize",rawName:"v-sanitize.basic",value:(_vm.html),expression:"html",modifiers:{"basic":true}}],staticClass:"html-container"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }